<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		:style="getWrapperStyle(node)"
		@click="onNodeClick(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<div class="stock-counter">
			<div class="stock-counter__label" v-html="generateLabel(node)">
				<!-- Stock yang tersisa hanya <b class="text-danger">{{ node.options.currentStock }}</b> saja loh -->
			</div>
			<div class="stock-counter__wrapper" :style="getMainStyle(node)">
				<div
					class="stock-counter__bar"
					:style="getBarStyle(node)">&nbsp;</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';

import {
	getNodeStyle,
	// eslint-disable-next-line
	getRgbaColor,
} from '@/lib/helper';

/**
 * Format double braced template string
 * @param {string} content "This is {{stock}}!"
 * @param {string} '<b>stock</b>'
 * @returns {string} "This is <b>Stock</b>!"
 */
const parsedLabelContent = (content, replace) => {
	const matchedContent = content.match(/[^{{}]*(?=\}})/g);
	const allSelectors = matchedContent && matchedContent.length > 0
		? matchedContent.filter(curr => curr !== '' && curr === 'stock')
		: [];
	const mapping = {};
	// eslint-disable-next-line
	allSelectors.forEach((e, i) => mapping[`{{${e}}}`] = replace);
	return content.replace(/\{{\w+\}}/ig, n => (n === '{{stock}}' ? mapping[n] : ''));
};

export default {
	name: 'NodeStockCounter',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
	},
	data() {
		return {
			isCanEdit: false,
			editor: null,
		};
	},
	mounted() {},
	methods: {
		...mapActions({
			setActionElement: 'funnels/setActionElement',
		}),
		getClass(node) {
			let pClass = node.class || '';
			if (node.options && node.options.align) {
				pClass += ` text-${node.options.align}`;
			}

			return pClass;
		},
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
				'line-height',
				'padding',
				'border',
				'bg-color',
				'bg-img',
				'box-shadow',
				'text-shadow',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
				'padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getMainStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'border',
				'bg-color',
				// 'height',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		// eslint-disable-next-line
		getBarStyle({ options }) {
			const current = options.currentStock;
			const max = options.maxStock;
			const height = options.height;
			const value = (current / max) * 100;
			const width = Math.ceil(value);
			const startColor = getRgbaColor(options.backgroundColorStart.rgb) || 'rgba(2,0,36,1)';
			const endColor = getRgbaColor(options.backgroundColorEnd.rgb) || 'rgba(0,212,255,1)';
			const style = {};
			style.width = `${width}%`;
			style.background = `linear-gradient(90deg, ${startColor} 0%, ${endColor} 100%)`;
			style.height = `${height}px`;
			return style;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
			// this.setActionElement({ type, node });
		},
		onInput(e) {
			const text = e.target.innerText;
			console.log('text: ', text);
			this.node.options.content = text;
			// this.$bus.$emit('change-panel-status', 'elements');
		},
		generateLabel({ options }) {
			const stock = `<b class="text-danger">${options.currentStock}</b>`;
			const label = options.label && options.label !== ''
				? parsedLabelContent(options.label, stock)
				: '';
			return label;
		},
	},
	computed: {
		style() {
			return this.getStyle(this.node);
		},
	},
};
</script>

<style lang="scss">
.stock-counter {
	margin:  0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;

	&__label {
		margin: 0 auto;
		padding-bottom: 1.5rem;
		font-size: 19px;
		font-weight: bold;
		text-align: center;

		b {
			padding: 0 .4rem;
			font-size: 26px;
			font-style: italic;
		}
	}

	&__wrapper {
		margin:  0 auto;
		width: 609px;
		max-width: 100%;
		// height: auto;
		// background-color: #f5f5f5;
	}

	&__bar {
		height: inherit;
		// background-color: gold;
		border-radius: inherit;
	}
}
</style>
